import React, { useMemo, useState } from "react";
import PopUpMenu from "../PopUpMenu/PopUpMenu";
import { MenuItem } from "@mui/material";
import EmailTransmissionReportModal from "./EmailTransmissionReportModal";
import ApiClient from "../../services/ApiClient";
import MediaObjectFormModal from "../Case/CaseUploadFile/MediaObjectFormModal";
import { EmailMessage } from "../../types/EmailMessage";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import DocumentClassLabelAiProvider from "../../provider/DocumentClassLabelAiProvider";
import ActionIdentifierProvider from "../../provider/ActionIdentifierProvider";
import { ProductUnion } from "../../types/ProductUnion";
import dayjs from "dayjs";

type EmailMoreMenuProps = {
  emailMessage: EmailMessage;
  product: ProductUnion;
  refetchEmails: Function;
};

export default function EmailMoreMenu({emailMessage, product, refetchEmails}: EmailMoreMenuProps) {
  const [emailTransmissionReportModalOpen, setEmailTransmissionReportModalOpen] = useState(false);
  const [addMailAsMediaObjectModalOpen, setAddMailAsMediaObjectModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = useCurrentUser();

  const toggleHiddenExternally = async () => {
    setIsLoading(true);
    await ApiClient.patch(emailMessage["@id"], {
      body: JSON.stringify({
        hiddenExternally: !emailMessage.hiddenExternally,
      }),
    });
    await refetchEmails();
    setIsLoading(false);
  };

  const transmissionReportDisabled = useMemo(() => {
    const sender = emailMessage.from?.email;
    return (
      !sender ||
      (sender !== "service@legalbird.de" && sender !== "anwalt@legalbird-kanzlei.de") ||
      dayjs(emailMessage.created).add(30, "days").isBefore(dayjs(), "days")
    );
  }, [emailMessage]);

  return (
    <>
      <PopUpMenu>
        <MenuItem onClick={() => setAddMailAsMediaObjectModalOpen(true)}>Als Datei hinzufügen</MenuItem>
        <MenuItem onClick={toggleHiddenExternally} disabled={isLoading}>
          Für Extern {emailMessage.hiddenExternally ? "sichtbar" : "unsichtbar"} machen
        </MenuItem>
        <MenuItem disabled={transmissionReportDisabled} onClick={() => setEmailTransmissionReportModalOpen(true)}>
          Sendebericht anfordern
        </MenuItem>
      </PopUpMenu>
      <EmailTransmissionReportModal
        emailMessage={emailMessage}
        product={product}
        isOpen={emailTransmissionReportModalOpen}
        setIsOpen={setEmailTransmissionReportModalOpen}
      />
      <DocumentClassLabelAiProvider>
        <ActionIdentifierProvider>
          <MediaObjectFormModal
            product={product}
            closeDialog={() => setAddMailAsMediaObjectModalOpen(false)}
            open={addMailAsMediaObjectModalOpen}
            requestUri={"/lb/services/generate_file_from_mail"}
            contentType={"application/json"}
            errorMessage={"Email konnte nicht umgewandelt werden"}
            fileData={{
              emailContent: emailMessage.messageContent.html || emailMessage.messageContent.text,
              originalName: `${dayjs(emailMessage.created).format("YYYYMMDD")}_${product.reference}_Email_von_${dayjs(
                emailMessage.created
              ).format("HH-mm")}Uhr.pdf`,
              createdBy: currentUser["@id"],
              emailInfoString: `E-Mail von <i>${emailMessage?.from?.email}</i> an <i>${
                emailMessage?.to?.email
              }</i> am ${dayjs(emailMessage.created).format("DD.MM.YYYY")} um ${dayjs(emailMessage.created).format(
                "HH:mm"
              )} Uhr | Betreff: ${emailMessage.messageContent.subject}`,
            }}
          />
        </ActionIdentifierProvider>
      </DocumentClassLabelAiProvider>
    </>
  );
}
